/* eslint-disable no-unused-vars */
/* eslint-disable require-jsdoc */
import React, { useState } from 'react';
import Calendar from 'react-calendar';
import PropTypes from 'prop-types';
import { debug } from '../../config';
import Dropdown from 'react-bootstrap/Dropdown'
import { getOption } from '../../utils/option';

const getDistText = (dist) => {
  return dist.toString() + ' mi';
}
const getDistKey = (dist) => {
  return dist.toString();
}

const defaultDropdownItems = [25, 12, 4];

const sanatizeDropdownItems = (items) => {

  if (!items || items.length === 0) {
    return defaultDropdownItems;
  }
  let sanitizedItems = [];
  for(let i = 0; i < 5; i++) {
    if(items[i] <= 125 && items[i] >= 1 && Number.isInteger(items[i])) {
      sanitizedItems.push(items[i]);
    }
  }
  return sanitizedItems;
}

export default function Distance(props) {
  const distOpts = props.psBarSettings.distanceOpts;
  let defaultDist = getOption(distOpts, 'defaultDistance', 25);
  defaultDist = defaultDist.toString() + " mi";
  const [distanceText, setDistanceText] = useState(defaultDist);

  let dropdownItems = getOption(distOpts, 'distanceValues', false);
  dropdownItems = sanatizeDropdownItems(dropdownItems);
  

  const handleChange = (e) => {
    // debug && console.log("set distance ", eventKey, ' ', event);
    debug && console.log("set distance ", e);
    setDistanceText(e + ' mi');
    props.setDistance(e);
  }

  return (
    <Dropdown className={'hearby-powersearch-dist-dropdown'}>
  <Dropdown.Toggle id="dropdown-basic">
    {distanceText}
  </Dropdown.Toggle>
  <Dropdown.Menu>
  {dropdownItems.map((dist) => {
    return (
      <Dropdown.Item onSelect={handleChange} eventKey={getDistKey(dist)}>{getDistText(dist)}</Dropdown.Item>
    );
    })}
  </Dropdown.Menu>
</Dropdown>
    
  );
// }
// CalendarComponent.propTypes = {
//   date: PropTypes.array,
//   setDate: PropTypes.func,
//   show: PropTypes.bool,
};